// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"2df08dbd","455":"223ec5d8","977":"3f30af1c"}[chunkId] + ".chunk.js";
};